export default {
  Navigation: {
    CHANGE_GROUP: 'Change Group',
    SWITCH_PRODUCT: 'Switch Product',
    CREATE_GROUP: 'Create Group',
    Recharger: {
      TITLE: 'Recharger',
      SOURCES: 'Sources',
      GROUPS: 'Group',
      APPORTIONMENTS: 'Apportionments',
      RULES: 'Rules',
      CALCULATIONS: 'Calculations',
    },
    LoanAccount: {
      TITLE: 'Balancer',
      DASHBOARD: 'Dashboard',
    },
    Brag: {
      TITLE: 'BRAG',
      SETUP: 'Setup',
      REC_LOG: 'Reconciliation Log',
    },
    ACCOUNT: 'Account',
    LOGOUT: 'Logout',
    SETTINGS: 'Settings',
    HELP: 'Help Centre',
    NOTIFICATIONS: 'Notifications',
  },
};
